export abstract class NameFormatter {
    abstract format(name: string) : string;
}